import {Rect} from "./engine/utils/Rect";
import {Position} from "./components/transform/position";
import {MoveGrabState} from "./components/grab/moveGrabState";
import {PumpSpeed} from "./components/inputObject/pumpSpeed";
import {Crank} from "./components/inputObject/crank";
import {Rotation, Scale} from "./components/transform/rotation";
import {PumpPressure} from "./components/inputObject/pumpPressure";
import {ImageRenderer} from "./components/image/imageRenderer";
import {EntityManager} from "./engine/tools/EntityManager";
import {Vector2} from "./engine/utils/Vector2";
import {GrabAnchor} from "./components/grab/grabAnchor";
import {Button} from "./components/inputObject/button";
import {RotationGrabState} from "./components/grab/rotationGrabState";
import {RotationMotor} from "./components/inputObject/rotationMotor";
import {PumpSound} from "./components/inputObject/pumpSound";
import {settings} from "./settings";


export function createCrank(entities:EntityManager, position: Vector2) {


    const spindle = entities.create(
        new Position(),
        new ImageRenderer("crank/crank-spindle")
    )
    const handleBg = entities.create(
        new Position(),
        new Rotation(),
        new ImageRenderer("crank/crank-handle-bg"),
    )
    const handleFg = entities.create(
        new Position(),
        new Rotation(),
        new ImageRenderer("crank/crank-handle-fg"),
    )
    const knob = entities.create(
        new Position(),
        new ImageRenderer("crank/crank-knob")
    )

    const crank = entities.create(
        new Position(position),
        new Rotation(0),
        new Crank({
            knob, spindle, handleBg, handleFg, locked: true
        }),
        new GrabAnchor(knob),
        new RotationMotor(),
        new RotationGrabState()
    )

    return crank
}



export function createButton(entities:EntityManager, pos: Vector2) {

    const button = entities.create(
        new Position(pos),
        new ImageRenderer(),
        new Button({
            downImage: "button/button-down",
            upImage: "button/button-up"
        }),
        new Scale(0.2,0.2)
    )
    return button
}

export function createPump(entities:EntityManager, pos: Vector2) {


    const handleOffset = new Vector2(0, -60)
    const handlePos = pos.add(handleOffset)
    entities.create(
        new Position(pos),
        new ImageRenderer("pump/bigpump-base"),
    )
    const handle = entities.create(
        new Position(handlePos),
        new ImageRenderer("pump/bigpump-lever"),
        new MoveGrabState({
            rect: new Rect(handlePos.x, handlePos.y, 0, 120)
        }),
        new PumpPressure(),
        new PumpSpeed({
            speed:settings.fast ? .5 : 0.04
        }),
        new PumpSound()
    )
    entities.create(
        new Position(pos),
        new ImageRenderer("pump/bigpump-mask"),
    )

    return handle
}
